import { render, staticRenderFns } from "./CtrlShukaArea.vue?vue&type=template&id=8f66b618&scoped=true&"
import script from "./CtrlShukaArea.vue?vue&type=script&lang=ts&"
export * from "./CtrlShukaArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f66b618",
  null
  
)

export default component.exports